module.exports = __webpack_public_path__ + "static/media/linkIconDark.28ba05b5.svg";